export default __webpack_public_path__ + "static/media/component_humidity_sensor.d4ab108b.png";